import { UnitType } from '@src/core/enums';
import { getUnitType } from '@src/core/features/settings/units';

const METERS_PER_MILE = 1609.344;

/**
 * Format a distance given in meters using the user's unit system:
 * SI -> "X km", IMPERIAL -> "X mi". Space is used as the thousands separator.
 */
export function formatFlightDistance(meters: number): string {
  const isImperial = getUnitType() === UnitType.IMPERIAL;
  const suffix = isImperial ? 'mi' : 'km';
  if (meters <= 0) return `0 ${suffix}`;
  const value = isImperial ? meters / METERS_PER_MILE : meters / 1000;
  return `${value.toLocaleString('en-US').replace(/,/g, ' ')} ${suffix}`;
}
